import axios from '@/api/axios-config'
import type { SnowflakeId } from '@/types/snowflake'
import type { Reminder, ReminderDraft } from '@/features/reminders/types'

/** 后端 BaseListResponse 解包后的 shape(axios 拦截器已剥掉 { code, data, msg } 外壳)。 */
export interface ReminderSearchResult {
  results: Reminder[]
  pagination: { page: number; pageSize: number; totalResults: number; totalPages: number }
}

export const remindersApi = {
  search: (data: Record<string, unknown>) =>
    axios.post('/pms/reminders/search', data) as Promise<ReminderSearchResult>,
  create: (data: ReminderDraft) => axios.post('/pms/reminders', data) as Promise<Reminder>,
  update: (id: SnowflakeId, data: Partial<ReminderDraft> & { status?: string; snoozedFrom?: string }) =>
    axios.put(`/pms/reminders/${id}`, data),
  remove: (id: SnowflakeId) => axios.delete(`/pms/reminders/${id}`),
}
